import { jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Dimensions.module.css';
const SEPARATOR = { fr: ' × ', en: ' × ' };
function formatNumber(value, lang) {
    return new Intl.NumberFormat(lang === 'fr' ? 'fr-FR' : 'en-US', {
        maximumFractionDigits: 1,
    }).format(value);
}
/** Dimensions d'une œuvre : « H × L (× P) cm », chiffres en Plex Mono `tabular-nums` (2.4). */
export function Dimensions({ height, width, depth, unit = 'cm', lang = 'fr', className, ...rest }) {
    const parts = [height, width, depth].filter((value) => value != null);
    const text = parts.map((value) => formatNumber(value, lang)).join(SEPARATOR[lang]);
    const classes = [styles.dimensions, className].filter(Boolean).join(' ');
    return (_jsxs("span", { className: classes, ...rest, children: [text, ' ', unit] }));
}
//# sourceMappingURL=Dimensions.js.map